module.exports = __webpack_public_path__ + "img/swimming_staging.0e0b1d64.jpeg";